import React from "react";
import { Shimmer } from "../../component-library/Shimmer";

const WatchCardLoading = () => {
  return (
    <div className="card__wrapper card__wrapper--video" data-testid="watch-card-loading">
      <div className="card">
        <div className="card__content">
          <div>
            <div style={{ width: "100%", marginBottom: "20px" }}>
              <Shimmer height="400px" width="100%" borderRadius="8px" />
            </div>

            <div style={{ marginBottom: "16px" }}>
              <Shimmer height="32px" width="80%" borderRadius="4px" />
            </div>

            <div style={{ display: "flex", alignItems: "center", flex: "1" }}>
              <Shimmer height="40px" width="40px" borderRadius="50%" />

              <Shimmer
                height="16px"
                width="120px"
                style={{ marginLeft: "8px" }}
                borderRadius="4px"
              />

              <Shimmer
                height="16px"
                width="100px"
                style={{
                  marginRight: "0px",
                  justifySelf: "flex-end",
                  marginLeft: "auto"
                }}
                borderRadius="4px"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WatchCardLoading;
